
export enum Cms {
    Wordpress = 1,
    Other = 2,
    Shoptet = 3,
}